import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React, { Fragment, useCallback, useMemo } from 'react';
import * as Yup from 'yup';
import CommentButton from 'components/buttons/Comment';
import CancelButton from 'components/buttons/Cancel';
import ReplyButton from 'components/buttons/Reply';
import CardActions from 'components/Card/Actions';
import CardText from 'components/Card/Text';
import EnhancedTextarea from 'components/EnhancedTextarea';
import LoadBlur from 'components/LoadBlur';
import RowSpacer from 'components/RowSpacer';

const CommentForm = ({
  autoFocus,
  // first,
  isReply,
  onCancel,
  onSave,
  saving,
  personId,
}) => {
  const cancelButton = useMemo(
    () => (onCancel ? <CancelButton onClick={onCancel} secondary /> : null),
    [onCancel],
  );
  // const placeholder = useMemo(() => {
  //   if (isReply) {
  //     return 'Add your two cents...';
  //   }
  //   return first ? 'Start the conversation!' : 'Join the conversation!';
  // }, [first, isReply]);
  const placeholder = useMemo(() => {
    if (isReply) {
      return 'Add your two cents...';
    }
    return personId === null ? 'Please Login...' : 'Join the conversation!';
  }, [personId]);
  return (
    <LoadBlur style={{ width: '100%' }} loading={saving}>
      <Formik
        initialValues={useMemo(
          () => ({
            body: '',
          }),
          [],
        )}
        onSubmit={onSave}
        validateOnBlur={false}
        validationSchema={useMemo(
          () => Yup.object().shape({
            body: Yup.string()
              .trim()
              .required('Comment is required'),
          }),
          [],
        )}
      >
        {useCallback(
          ({
            dirty,
            errors,
            handleBlur,
            handleChange,
            isSubmitting,
            isValid,
            submitForm,
            values,
          }) => {
            const canSave = dirty && isValid && !isSubmitting;
            return (
              <Fragment>
                <CardText>
                  <EnhancedTextarea
                    autoFocus={autoFocus}
                    disabled={isSubmitting}
                    errorText={errors?.body}
                    name='body'
                    onBlur={handleBlur}
                    onChange={handleChange}
                    placeholder={placeholder}
                    value={values.body}
                  />
                </CardText>
                <CardActions noTopPadding>
                  <RowSpacer />
                  {cancelButton}
                  {isReply ? (
                    <ReplyButton
                      disabled={!canSave}
                      onClick={submitForm}
                      primary={canSave}
                    />
                  ) : (
                    <CommentButton
                      disabled={personId === null || !canSave}
                      onClick={submitForm}
                      primary={canSave}
                    />
                  )}
                </CardActions>
              </Fragment>
            );
          },
          [autoFocus, cancelButton, isReply, placeholder],
        )}
      </Formik>
    </LoadBlur>
  );
};

CommentForm.propTypes = {
  autoFocus: PropTypes.bool,
  first: PropTypes.bool,
  personId: PropTypes.number,
  isReply: PropTypes.bool,
  onCancel: PropTypes.func,
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool,
};

export default CommentForm;
